import {SHOW_CACHE_FLAG, HIDE_CACHE_FLAG} from '../action/cacheFlag.js';

export default (state = false, action) => {
  switch (action.type) {
    case SHOW_CACHE_FLAG: {
      return true;
    }
    case HIDE_CACHE_FLAG: {
      return false;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducer/isCacheUseful.js